import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { TIDS } from "@/constants/testIds";
import { Plus, ExternalLink, Copy, Users, Layers } from "lucide-react";
import { toast } from "sonner";

const fmtINR = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export default function Courses() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/courses");
    setRows(data); setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const copyPublic = (slug) => {
    navigator.clipboard.writeText(`${window.location.origin}/c/${slug}`);
    toast.success("Course landing page link copied");
  };

  return (
    <div className="space-y-6 vp-fade-up">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="vp-label">Courses</div>
          <h1 className="font-display text-3xl font-bold mt-1">Cohorts &amp; multi-session courses</h1>
          <p className="text-[#4A4D57] mt-2 text-sm max-w-xl">Bundle multiple webinars into a paid course. Attendees enroll once — get auto-enrolled into every session.</p>
        </div>
        <Link to="/app/courses/new" data-testid={TIDS.courseNewBtn} className="vp-btn-primary inline-flex items-center gap-2">
          <Plus className="w-4 h-4" /> New course
        </Link>
      </div>

      {loading ? (
        <div className="text-[#4A4D57]">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="vp-card p-10 text-center">
          <div className="w-12 h-12 rounded-2xl bg-[#0B5CFF]/10 flex items-center justify-center mx-auto mb-4">
            <Layers className="w-6 h-6 text-[#0B5CFF]" strokeWidth={1.5} />
          </div>
          <div className="font-display font-bold text-xl">No courses yet</div>
          <p className="text-[#4A4D57] mt-2 text-sm max-w-md mx-auto">Create your first cohort by bundling 2-4 existing webinars.</p>
          <Link to="/app/courses/new" className="vp-btn-primary mt-5 inline-block">Create your first course</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rows.map((c) => (
            <div key={c.id} className="vp-card vp-card-hover p-5 flex flex-col" data-testid={TIDS.courseRow}>
              <div className="flex items-start justify-between gap-3">
                <Link to={`/app/courses/${c.id}`} className="font-display font-bold text-lg hover:text-[#0B5CFF] leading-snug">
                  {c.title}
                </Link>
                <span className="vp-chip">{c.schedule_kind}</span>
              </div>
              <p className="text-sm text-[#4A4D57] mt-2 line-clamp-2">{c.description}</p>
              <div className="mt-4 flex items-center gap-3 text-sm">
                <span className="font-display font-bold">{c.price > 0 ? fmtINR(c.price) : "Free"}</span>
                <span className="text-[#747680]">·</span>
                <span className="text-[#747680] inline-flex items-center gap-1"><Layers className="w-3.5 h-3.5" /> {c.webinar_ids?.length || 0} modules</span>
              </div>
              <div className="mt-auto pt-4 flex gap-2">
                <button onClick={() => copyPublic(c.slug)} className="vp-btn-ghost text-xs inline-flex items-center gap-1 py-1.5 px-3">
                  <Copy className="w-3.5 h-3.5" /> Link
                </button>
                <a href={`/c/${c.slug}`} target="_blank" rel="noreferrer" className="vp-btn-ghost text-xs inline-flex items-center gap-1 py-1.5 px-3">
                  <ExternalLink className="w-3.5 h-3.5" /> Preview
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
